"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../utils");
var StyledDataTable = styled_components_1.default.table(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-spacing: 0;\n  border-collapse: collapse;\n  height: 100%;\n  ", ";\n"], ["\n  border-spacing: 0;\n  border-collapse: collapse;\n  height: 100%;\n  ", ";\n"])), utils_1.genericStyles);
exports.StyledDataTable = StyledDataTable;
var StyledDataTableRow = styled_components_1.default.tr(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.size &&
        "\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
});
exports.StyledDataTableRow = StyledDataTableRow;
var StyledDataTableBody = styled_components_1.default.tbody(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.size &&
        "\n    display: block;\n    width: 100%;\n    max-height: " + props.theme.global.size[props.size] + ";\n    overflow: auto;\n  ";
});
exports.StyledDataTableBody = StyledDataTableBody;
var StyledDataTableHeader = styled_components_1.default.thead(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.size &&
        "\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
});
exports.StyledDataTableHeader = StyledDataTableHeader;
var StyledDataTableFooter = styled_components_1.default.tfoot(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.size &&
        "\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
});
exports.StyledDataTableFooter = StyledDataTableFooter;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=StyledDataTable.js.map